import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { CheckoutPage, ResultPage, StatusPage } from './pages';
import { getBasename } from './utils/site';
import './App.css';

const theme = {
  token: {
    colorPrimary: '#1a5c3a',
    borderRadius: 2,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
};

function App() {
  const basename = getBasename();

  return (
    <ConfigProvider theme={theme}>
      <Router basename={basename} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<Navigate to="/pay" replace />} />
          <Route path="/pay" element={<CheckoutPage />} />
          <Route path="/pay/result" element={<ResultPage />} />
          <Route path="/pay/status/:gatewayOrderNo" element={<StatusPage />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;
